import * as Sentry from '@sentry/react';
import React, { ReactElement } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Login from './components/Login';
import PasswordForgot from './components/PasswordForgot';
import PasswordReset from './components/PasswordReset';
import Registration from './components/Registration';
import { ArkoseContextProvider } from './providers/ArkoseContext';

interface Analytics extends SegmentAnalytics.AnalyticsJS {
  initialized: boolean | undefined;
  invoked: boolean | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  track: (event: string, props: any) => void;
}

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setupEnforcement?: (enforcement: any) => void;
    analytics?: Analytics;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _sift?: any;
  }
}

export function App(): ReactElement {
  return (
    <ArkoseContextProvider>
      <Router>
        <Route path="/registrations/new" component={Registration} />
        <Route path="/login" component={Login} />
        <Route path="/forgot_password/new" component={PasswordForgot} />
        <Route path="/password_resets/*" component={PasswordReset} />
      </Router>
    </ArkoseContextProvider>
  );
}

export default Sentry.withProfiler(App);
